import React, { HTMLProps, useRef, useState } from "react";
import { BiMinus, BiPlus } from "react-icons/bi";
import "./styles.scss";

interface DetailItemProps extends HTMLProps<HTMLDetailsElement>{
  title: string;
  text: string;
}

function DetailItem({ title, text, ...rest }: DetailItemProps) {
  const [active, setActive] = useState(false);
  const detailsRef = useRef<HTMLDetailsElement>(null);

  return (
    <details ref={detailsRef} {...rest}>
      <summary onClick={() => setActive(!active)}>
        {title}
        <button className={`${active ? "active" : "inactive"}`}>
          {active ? <BiMinus /> : <BiPlus />}
        </button>
      </summary>
      <div
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    </details>
  );
}

export { DetailItem };
